import React from 'react';
import { Header } from './components/Header';
import { HomePage } from './pages/HomePage';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <HomePage data-id="element-2" />
    </div>;
}